import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  notificationSchoolMockData,
  notificationStudentMockData,
} from "src/services/notification-mock-data/notification-mock-data";
import ReactStars from "react-stars";
import { Form, Formik, useFormik } from "formik";
import { evaluateSchoolValidation } from "src/components/user/validation/evaluate-school-validation";
function NotificationsContainer() {
  const { i18n, t } = useTranslation();
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const evaluatePopupRef = useRef<HTMLDivElement>(null);
  const [rating, setRating] = useState<number>(0);
  const dummyNotificationData =
    localStorage.getItem("role") === "student"
      ? notificationStudentMockData
      : notificationSchoolMockData;
  type InitialValuesType = {
    rate: number;
    comment: string;
  };
  const initialValues: InitialValuesType = {
    rate: 0,
    comment: "",
  };
  useEffect(() => {
    const handleClickOutSideForm = ({ target }: MouseEvent) => {
      if (!evaluatePopupRef?.current?.contains(target as Node)) {
        setOpenPopup(false);
      }
    };
    document.body.addEventListener("click", handleClickOutSideForm, true);

    return () => {
      document.body.removeEventListener("click", handleClickOutSideForm);
    };
  }, []);
  const handleRatingChange = (newRating: number) => {
    setRating(newRating);
    formik.setFieldValue("rate", rating);
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: evaluateSchoolValidation,
    onSubmit: async () => {
      setOpenPopup(false);
    },
  });
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col gap-8"
    >
      <div className="text-zinc-500 text-xl font-arMedium">
        {t("notifications.container.notifications")}
      </div>
      {dummyNotificationData.map((item, index) => (
        <div
          className="flex flex-col border-b border-[#CBD5E1] pb-2 mt-1"
          key={index}
        >
          <div className="flex flex-row justify-between">
            {item.read ? (
              <div className="rounded-full bg-transparent h-2.5 w-2.5"></div>
            ) : (
              <div className="rounded-full bg-secondary-50 h-2.5 w-2.5"></div>
            )}
          </div>
          <div className="font-ar text-M3 text-base px-3">
            {i18n.language === "ar" ? item.title : item.titleEn}
          </div>
          {item.forEvolution ? (
            <div className="font-ar text-zinc400 text-xs pt-2 px-3">
              {i18n.language === "ar" ? item.description : item.descriptionEn}{" "}
              <span className="font-arBold">
                {i18n.language === "ar" ? item.title : item.titleEn}
              </span>
            </div>
          ) : (
            <div className="font-ar text-zinc400 text-xs pt-2 px-3">
              {i18n.language === "ar" ? item.description : item.descriptionEn}
            </div>
          )}
          {item.forEvolution && (
            <div>
              <button
                onClick={() => setOpenPopup(true)}
                className="w-[114px] h-8 my-2 mx-3 bg-mint-500 rounded-lg text-white text-base font-arMedium"
              >
                {t("evaluateSchool.container.addEvaluation")}
              </button>
            </div>
          )}
          <div
            dir="ltr"
            className={`${
              i18n.language === "ar" ? "flex-row" : "flex-row-reverse"
            } flex justify-end font-ar text-zinc400 text-xs pt-2 px-3`}
          >
            {item.time}
          </div>
        </div>
      ))}
      {openPopup && (
        <div
          ref={evaluatePopupRef}
          className="fixed top-0 left-0 inset-y-0 inset-x-0 mx-auto my-auto bg-white shadow-[rgba(0,_0,_0,_0.10)_0px_0px_20px_0px] w-[505px] h-[381px] p-8 laptop:w-[505px] mobile:w-[321px] mobile:h-[370px] tablet:w-[480px] tablet:h-[550x] rounded-2xl"
        >
          <Formik
            initialValues={initialValues}
            validationSchema={evaluateSchoolValidation}
            onSubmit={() => formik.submitForm()}
          >
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
              }}
              className="flex flex-col gap-6 mobile:gap-4"
            >
              <p className="text-slate-600 text-xl font-arBold">
                {t("evaluateSchool.container.evaluateSchool")}
              </p>
              <div dir="ltr" className="flex justify-center">
                <ReactStars
                  count={5}
                  onChange={handleRatingChange}
                  size={40}
                  color1="#E4E4E7"
                  color2="#FBBF24"
                  value={rating}
                />
              </div>
              <textarea
                value={formik.values.comment}
                id="comment"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`${
                  formik.touched.comment && formik.errors.comment
                    ? "border-secondary-50 focus:border-secondary-50"
                    : "border-zinc400 focus:border-mint-500"
                } focus:border-mint-500 w-[425px] h-32 resize-none bg-transparent mobile:max-w-[260px] mobile:w-[calc(100vw-136px)] mobile:h-32 px-4 py-[17px] rounded-[18px] border placeholder:text-neutral-500 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                placeholder={`${t("evaluateSchool.container.writeComment")}`}
              ></textarea>

              <button
                type="submit"
                className="w-[425px] h-[45px] mobile:w-[257px] text-white text-xl font-arBold bg-mint-500 rounded-2xl"
              >
                {t("evaluateSchool.container.add")}
              </button>
            </Form>
          </Formik>
        </div>
      )}
    </div>
  );
}

export default NotificationsContainer;
